const idle = {
  images: [require('assets/sprites/dodo/idle.png')],

  framerate: 10,
  frames: [
    [484, 1, 235, 208, 0, 117.5, 208], //1
    [246, 1, 236, 208, 0, 118, 208], //2
    [1, 211, 238, 208, 0, 119, 208], //3
    [481, 211, 236, 208, 0, 118, 208], //4
    [1, 1, 243, 208, 0, 121.5, 208], //5
    [241, 211, 238, 208, 0, 119, 208], //6
    [721, 1, 235, 208, 0, 117.5, 208], //7
    [719, 211, 234, 209, 0, 117, 209] //8
  ],

  animations: {
    'idle(5)': { frames: [0] },
    'idle(3)': { frames: [1] },
    'idle(6)': { frames: [2] },
    'idle(2)': { frames: [3] },
    'idle(4)': { frames: [4] },
    'idle(1)': { frames: [5] },
    'idle(8)': { frames: [6] },
    'idle(7)': { frames: [7] }
  }
};
const walk = {
  images: [require('assets/sprites/dodo/walk.png')],

  framerate: 10,
  frames: [
    [481, 1, 234, 208, 0, 117, 208],
    [1, 1, 238, 209, 0, 119, 209],
    [242, 211, 233, 206, 0, 116.5, 206],
    [717, 1, 228, 204, 0, 114, 204],
    [477, 211, 223, 206, 0, 111.5, 206],
    [1, 212, 239, 205, 0, 119.5, 205],
    [241, 1, 238, 208, 0, 119, 208],
    [702, 211, 239, 202, 0, 119.5, 202]
  ],

  animations: {
    'walk(2)': { frames: [0] },
    'walk(6)': { frames: [1] },
    'walk(7)': { frames: [2] },
    'walk(3)': { frames: [3] },
    'walk(5)': { frames: [4] },
    'walk(1)': { frames: [5] },
    'walk(4)': { frames: [6] },
    'walk(8)': { frames: [7] }
  }
};
const dead = {
  images: [require('assets/sprites/dodo/dead.png')],

  framerate: 5,
  frames: [
    [267, 1, 235, 208, 0, 117.5, 208], //1
    [1, 622, 264, 188, 0, 132, 188], //2
    [1, 429, 264, 191, 0, 132, 191], //3
    [1, 812, 263, 196, 0, 131.5, 196], //4
    [1, 225, 264, 202, 0, 132, 202], //5
    [1, 1, 264, 222, 0, 132, 222], //6
    [266, 812, 151, 128, 0, 75.5, 128], //7
    [267, 686, 147, 119, 0, 73.5, 119], //8,
    [267, 566, 156, 118, 0, 78, 118], //9
    [267, 445, 166, 119, 0, 83, 119], //10
    [267, 325, 174, 118, 0, 87, 118], //11
    [267, 211, 176, 112, 0, 88, 112] //12
  ],

  animations: {
    'dead(6)': { frames: [0] },
    'dead(1)': { frames: [1] },
    'dead(12)': { frames: [2] },
    'dead(5)': { frames: [3] },
    'dead(11)': { frames: [4] },
    'dead(3)': { frames: [5] },
    'dead(10)': { frames: [6] },
    'dead(9)': { frames: [7] },
    'dead(2)': { frames: [8] },
    'dead(4)': { frames: [9] },
    'dead(7)': { frames: [10] },
    'dead(8)': { frames: [11] }
  }
};
const dodo1 = {
  idle,
  walk,
  dead
};
export default dodo1;
